"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
__export(require("./singleton"));
__export(require("./Retainable"));
__export(require("./Observable"));
__export(require("./BaseService"));
__export(require("./UrlState/UrlState"));
__export(require("./extractErrorMessage"));
var AppConfig_1 = require("./AppConfig");
exports.AppConfig = AppConfig_1.AppConfig;
var AuthenticationService_1 = require("./AuthenticationService");
exports.AuthenticationService = AuthenticationService_1.AuthenticationService;
var BaseEntitiesService_1 = require("./services/BaseEntitiesService");
exports.BaseEntitiesService = BaseEntitiesService_1.BaseEntitiesService;
__export(require("./RtService"));
// TODO: use @babel/plugin-proposal-export-namespace-from
// export * as repo from "./repositories";
// export * as srv from "./services";
var repo = __importStar(require("./repositories"));
exports.repo = repo;
var srv = __importStar(require("./services"));
exports.srv = srv;
// /**
//  * Creates a greeting message.
//  *
//  * @param name - Name to be used in the greeting message.
//  */
// export function greeter(name: string): string {
//   return `Hello ${name}, what can I do for you?`;
// }
